import type { ChartDataItem } from "../types";

export type XDomain = Array<string | number>;

export interface PrevSeriesMapping {
  prevPoints: Array<{ x: string | number; y: number }> | null;
  prevValuesOrdered: number[];
}

export const mapPrevSeriesToCurrentDomain = (
  previousData: ChartDataItem[] | undefined,
  seriesKey: string,
  currentXDomain: XDomain,
  indexBy: string,
): PrevSeriesMapping => {
  if (!previousData || previousData.length === 0) {
    return { prevValuesOrdered: [], prevPoints: null };
  }

  const sortedPreviousData = [...previousData].sort((a, b) => {
    const aVal = a[indexBy];
    const bVal = b[indexBy];
    if (aVal == null || bVal == null) return 0;
    return String(aVal).localeCompare(String(bVal));
  });

  const prevValuesOrdered = sortedPreviousData.map(item => {
    const raw = item[seriesKey];
    return typeof raw === "number" ? raw : Number(raw ?? 0);
  });

  const len = Math.min(currentXDomain.length, prevValuesOrdered.length);
  if (len === 0) {
    return { prevValuesOrdered, prevPoints: null };
  }

  const prevPoints: Array<{ x: string | number; y: number }> = [];
  for (let i = 0; i < len; i += 1) {
    prevPoints.push({ x: currentXDomain[i], y: prevValuesOrdered[i] });
  }

  return { prevValuesOrdered, prevPoints };
};
